export const ENV = process.env.REACT_APP_ENV
export const RSA_PUBLIC_KEY = process.env.REACT_APP_RSA_PUBLIC_KEY
export const API = process.env.REACT_APP_API
export const MP_PUBLIC = process.env.REACT_APP_MP_PUBLIC || ''